import { RevenueManagementService } from "../Services/revenue-management.service";
import { Component } from "@angular/core";
import { ActiveSuppliers, Agency_Branches } from "../Models/ActiveClasses";
import { Router } from "@angular/router";
import { RevenueReportPropertise } from "../Models/RevenueManagementProperties";
import { Observable, of, Subject } from "rxjs";
import { RevenueManagementProperties } from "../Models/RevenueManagementProperties";
import { faAngleRight, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-group-revenue-report',
  templateUrl: './group-revenue-report.component.html',
  styleUrls: ['./group-revenue-report.component.css']
})

export class GroupRevenueReportComponent {
  constructor(public revenueService: RevenueManagementService, private router: Router, private messageservice: MessageService){
    
  }
  faAngleRight = faAngleRight;
  faAngleDoubleRight = faAngleDoubleRight;
  agency_branchesList$: Observable<Agency_Branches[]>;
  primeShowModalBeneficiaryModel: boolean = false;
  minDate: string = "";
  isPNR = false;
  agencyList: string[] = [];
  agencyCodeList:string[] = [];
  agencynewCodeList:string[] = [];
  agencynewList:string[] = [];
  RevenueReportData= new RevenueReportPropertise();
  GroupRevenue: RevenueReportPropertise[] = [];
  GroupedList: boolean = false;
  SaveButton: boolean = false;
  ModifyButton: boolean = false;
  AgencyBranchList: any;
  myFiles: string[] = [];
  detailList = [];
  checkboxState: boolean[] = [];
  ngOnInit(){
    this.getAgency();  
    this.LoadGroupRevenue();
  }

  getAgency(){
    this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.agency_branchesList$ = of(data);
      this.AgencyBranchList = data;
      data.forEach(dat => {
        this.agencyList.push(dat.name);
        this.agencyCodeList.push(dat.code);
      });
    });
  }

  LoadGroupRevenue(){
    this.revenueService.GetGroupRevenueReport().subscribe(data => {
      if(data != null){
        console.log(data);
        this.GroupRevenue = data;
      }
    })
  }

  shiftAgency(){
    this.agencynewList = [];
    this.agencynewCodeList = [];
    let checkedValues = [];
    for(let i = 0; i < this.checkboxState.length; i++){
      if(this.checkboxState[i]){
          checkedValues.push(i);
      }
    }
    for(let i = 0; i < checkedValues.length; i++){
      this.agencynewList.push(this.agencyList[checkedValues[i]]);
      this.agencynewCodeList.push(this.agencyCodeList[checkedValues[i]]);
    }
    this.GroupedList = true;
  }

  shiftAllAgencies(){
    this.agencynewList = [];
    this.agencynewCodeList = [];
    for(let i = 0; i < this.agencyList.length; i++){
      this.agencynewList.push(this.agencyList[i]);
      this.agencynewCodeList.push(this.agencyCodeList[i]);
    }
    this.GroupedList = true;
  }

  SaveRevenueGroup(){
    if (this.RevenueReportData.groupName == "") {
      document.getElementById('messagename').style.color = 'red';
      document.getElementById('messagename').innerHTML = 'This Field is Required';
      return;
    } else {
      document.getElementById('messagename').style.color = 'red';
      document.getElementById('messagename').innerHTML = '';
    }
    if (!this.grouprevenuenamecheck(this.RevenueReportData.groupName)) {
      return;
    }
    if (this.RevenueReportData.expiryDate == "") {
      document.getElementById('messageexpiryDate').style.color = 'red';
      document.getElementById('messageexpiryDate').innerHTML = 'This Field is Required';
      return;
    }
    else {
      document.getElementById('messageexpiryDate').style.color = 'red';
      document.getElementById('messageexpiryDate').innerHTML = '';
    }

    if (this.agencynewCodeList.length == 0) {
      document.getElementById('AgencyCheck').style.color = 'red';
      document.getElementById('AgencyCheck').innerHTML = 'This Field is Required';
      return;
    }
    else {
      document.getElementById('AgencyCheck').style.color = 'red';
      document.getElementById('AgencyCheck').innerHTML = '';
    }
    this.RevenueReportData.agencyCodeList = this.agencynewCodeList;
    this.RevenueReportData.CreationUser = localStorage.getItem('UserId') || "";
    this.RevenueReportData.agencyId = localStorage.getItem('AgencyId') || "";

    this.revenueService.SaveRevenueReportData(this.RevenueReportData).subscribe((data) => {
      if (data) {
        this.primeShowModalBeneficiaryModel = false;
        this.messageservice.add({ severity: 'success', summary: 'Successfully', detail: 'Data Saved Successfully' });
        this.LoadGroupRevenue();
        
      }
    else {
          this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'Data not Saved' });
        }
      
    });
  }

  ClearSelection(index: number){
    let agClear = this.agencynewList.splice(index, 1);
    let x = this.agencynewCodeList.splice(index, 1);
    let ch = document.getElementsByClassName('AgencyCheckBoxes') as HTMLCollectionOf<HTMLInputElement>;
    

    for(let i = 0; i < this.checkboxState.length; i++){
      for (let j = 0; j < agClear.length; j++){
        if (this.AgencyBranchList[i].name == agClear[j]){
          this.checkboxState[i] = false;
        }
      }
    }
  }

  groupToBeModified: number = 0;
  EditGroupRevenue(id){
    this.agencynewList = [];
    this.agencynewCodeList = [];
    this.primeShowModalBeneficiaryModel = true;
    this.ModifyButton = true;
    this.SaveButton = false;
    this.groupToBeModified = id;
    this.revenueService.GetGroupRevenueByGroupId(id).subscribe(data =>{
      console.log(data);
      if(data != null){
        this.RevenueReportData.groupName = data.groupName;
        this.RevenueReportData.expiryDate = data.expiryDate;
        this.agencynewCodeList = data.agencyCodeList;
        let ch = document.getElementsByClassName('AgencyCheckBoxes');
        for(let i = 0; i < ch.length; i++){
          for(let j = 0; j < data.agencyCodeList.length; j++){
            if(this.AgencyBranchList[i].code == data.agencyCodeList[j]){
                this.checkboxState[i] = true;
                this.agencynewList.push(this.AgencyBranchList[i].name);
                break;
            }
            else{
              this.checkboxState[i] = false;
            }
          }
        }
      }
      else{
        this.router.navigateByUrl('/GroupRevenueReport');
        this.primeShowModalBeneficiaryModel = false;
        this.LoadGroupRevenue();
      }
    })
  }

  ModifyRevenueGroup() {
    if (this.RevenueReportData.groupName == "") {
      document.getElementById('messagename').style.color = 'red';
      document.getElementById('messagename').innerHTML = 'This Field is Required';
      return;
    } else {
      document.getElementById('messagename').style.color = 'red';
      document.getElementById('messagename').innerHTML = '';
    }

    if (this.RevenueReportData.expiryDate == "") {
      document.getElementById('messageexpiryDate').style.color = 'red';
      document.getElementById('messageexpiryDate').innerHTML = 'This Field is Required';
      return;
    }
    else {
      document.getElementById('messageexpiryDate').style.color = 'red';
      document.getElementById('messageexpiryDate').innerHTML = '';
    }

    if (this.agencynewCodeList.length == 0) {
      document.getElementById('AgencyCheck').style.color = 'red';
      document.getElementById('AgencyCheck').innerHTML = 'This Field is Required';
      return;
    }
    else {
      document.getElementById('AgencyCheck').style.color = 'red';
      document.getElementById('AgencyCheck').innerHTML = '';
    }
    this.RevenueReportData.agencyCodeList = this.agencynewCodeList;
    this.RevenueReportData.CreationUser = localStorage.getItem('UserId') || "";
    this.RevenueReportData.agencyId = localStorage.getItem('AgencyId') || "";
    this.RevenueReportData.groupId = this.groupToBeModified;
    this.revenueService.ModifyRevenueGroup(this.RevenueReportData).subscribe((data) => {
      if (data) {
        this.primeShowModalBeneficiaryModel = false;
        this.LoadGroupRevenue();
      }
    });
  }

  AddNewRevenueGroup() {
    this.RevenueReportData = new RevenueReportPropertise();
    this.primeShowModalBeneficiaryModel = true;
    this.SaveButton = true;
    this.ModifyButton = false;
    this.agencynewList = [];
    this.agencynewCodeList = [];
    this.checkboxState = [];
 
  }

  DeleteGroup(groupid: number) {
    this.revenueService.DelGroupRevenue(groupid).subscribe(data => {
      if (data) {
        this.router.navigateByUrl('/GroupRevenueReport');
        this.LoadGroupRevenue();
        this.messageservice.add({ severity: 'success', summary: 'Successfully', detail: 'Data Deleted Successfully' });
      }
      else {
        this.messageservice.add({ severity: 'error', summary: 'Fail', detail: 'Data not Saved' });
      }
    })
  }
  grouprevenuenamecheck(name: string): boolean{
    if (this.GroupRevenue.find(f => f.groupName == name)) {
      this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Group Name Already Exist.' });
      return false;
    }
    else {
      return true;
    }
  }
}
